<form id="message-edit">
    <span>Message</span>
    <span>Default</span>
    <span>Delete</span>
    {#each messages || [] as message, index (message)}
        <input type="text" class="message-input" placeholder="Message" value={message}>
        <input type="radio" name="default-message" id="default-message-{index}"
            value={message}  checked={message == default_message}>
        <input type="checkbox" value={message} id="delete-message-{index}">
    {/each}
</form>

<style>
    #message-edit {
        display: grid;
        grid-template-columns: auto auto auto;
        justify-content: start;
        justify-items: center;
        gap: 1vh;
    }
    .message-input {
        width: 40vw;
    }
</style>

<script>
    export let messages = []
    export let default_message = ''
</script>